import React from "react";
import Select from "react-select";

const FormInupt = (props) => {
  let invalidFields = props.invalidFields;
  return (
    <div
      className={
        invalidFields.includes(props.name) ||
        (invalidFields.includes("phoneRegex") &&
          props.name.includes("phone")) ||
        (invalidFields.includes("emailRegex") &&
          props.name.includes("email")) ||
        (invalidFields.includes("nipRegex") && props.name.includes("nip")) ||
        (invalidFields.includes("urlRegex") && props.name.includes("website"))
          ? "invalid"
          : ""
      }
    >
      {props.label ? (
        <label className={props.required ? "required" : ""}>
          {props.label}
        </label>
      ) : null}
      {props.options ? (
        <Select
          name={props.name}
          onChange={props.onChange}
          options={props.options}
          classNamePrefix="custom-select"
          placeholder={props.placeholder}
          isSearchable={false}
          noOptionsMessage={() => "Brak wyników"}
          className="redress-select"
        />
      ) : (
        <input
          style={props.style}
          id={props.id}
          type={props.type}
          value={props.value || ""}
          disabled={props.disabled || false}
          placeholder={props.placeholder}
          onChange={props.onChange}
          name={props.name}
          min={props.min || 0}
          max={props.max || 100}
        ></input>
      )}
    </div>
  );
};

FormInupt.defaultProps = {
  type: "text",
};

export default FormInupt;
